module.exports = __webpack_public_path__ + "img/v4_tradeReport_h.5ee838df.png";